import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ResourcesComponent} from "./resources-component/resources.component";
import {CreateResourceComponent} from "./create-resource/create-resource.component";
import {ResourcesEntryComponent} from "./resources-entry/resources-entry.component";

export const routes: Routes = [
    {
        path: '', component: ResourcesEntryComponent,
        children: [
            {path: 'list', component: ResourcesComponent, data: {state: 'lazy1'}},
            {path: 'new', component: CreateResourceComponent},
            {path: 'importer', component: CreateResourceComponent},
            {path: 'importer/:mime', component: CreateResourceComponent}
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ResourcesRoutingModule {
}
